export default "__VITE_ASSET__CRCP0zXR__"